import { render, staticRenderFns } from "./AITest.vue?vue&type=template&id=03b3e43e&scoped=true"
import script from "./AITest.vue?vue&type=script&lang=js"
export * from "./AITest.vue?vue&type=script&lang=js"
import style0 from "./AITest.vue?vue&type=style&index=0&id=03b3e43e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b3e43e",
  null
  
)

export default component.exports